// Auth0 configuration — ported from asi_ui (src/auth0.ts).
// Persist the Auth0 cache in localStorage on localhost to avoid dev cache issues.
const persistCache = (origin) => {
  const { hostname } = new URL(origin)
  return hostname === 'localhost' || hostname === '127.0.0.1'
}

export function getAuth0Config(origin = window.location.origin) {
  const config = {
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    authorizationParams: {
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      // /login-sso matches the qbiq Auth0 app's registered callback URLs.
      redirect_uri: `${origin}/login-sso`,
    },
  }

  if (persistCache(origin)) config.cacheLocation = 'localstorage'

  return config
}
